
export function f_mieux_meilleur(text) {
    return `

    <div class=WordSection1>

    <p class=MsoNormal style='line-height:normal;background:white;vertical-align:
    baseline'><span style='font-size:13.0pt;font-family:"Georgia",serif;color:#282828'>Like&nbsp;<i><span
    style='border:none windowtext 1.0pt;padding:0cm'>bon</span></i>&nbsp;and&nbsp;<i><span
    style='border:none windowtext 1.0pt;padding:0cm'>bien</span></i>,&nbsp;<i><span
    style='border:none windowtext 1.0pt;padding:0cm'>meilleur</span></i>&nbsp;and&nbsp;<i><span
    style='border:none windowtext 1.0pt;padding:0cm'>mieux</span></i>&nbsp;can be
    confusing for French students.&nbsp;<i><span style='border:none windowtext 1.0pt;
    padding:0cm'>Meilleur</span></i>&nbsp;is the&nbsp;<a
    href="https://www.thoughtco.com/french-comparative-and-superlative-adverbs-1368803"><span
    style='color:#0086A6'>comparative and superlative</span></a>&nbsp;form of the
    adjective&nbsp;<i><span style='border:none windowtext 1.0pt;padding:0cm'>bon</span></i>&nbsp;(good),
    while&nbsp;<i><span style='border:none windowtext 1.0pt;padding:0cm'>mieux</span></i>&nbsp;is
    the comparative and superlative form of the adverb&nbsp;<i><span
    style='border:none windowtext 1.0pt;padding:0cm'>bien</span></i>&nbsp;(well).
    When translating into English, there is no difference between&nbsp;<i><span
    style='border:none windowtext 1.0pt;padding:0cm'>meilleur</span></i>&nbsp;and&nbsp;<i><span
    style='border:none windowtext 1.0pt;padding:0cm'>mieux</span></i>, hence the
    confusion.</span></p>
    
    <table class=MsoNormalTable border=0 cellspacing=0 cellpadding=0
     style='border-collapse:collapse'>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'></td>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-left:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>Forms of&nbsp;</span></b><i><span
      style='font-size:13.0pt;font-family:"Times New Roman",serif;border:none windowtext 1.0pt;
      padding:0cm'>meilleur</span></i></p>
      </td>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-left:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>Forms of&nbsp;</span></b><i><span
      style='font-size:13.0pt;font-family:"Times New Roman",serif;border:none windowtext 1.0pt;
      padding:0cm'>mieux</span></i></p>
      </td>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-left:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>English translation</span></b></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'><a
      href="https://www.thoughtco.com/french-comparative-adverbs-1368820"><span
      style='color:#0086A6'>comparative</span></a></span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>meilleur, meilleure<br>
      meilleurs, meilleures</span></i></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>mieux</span></i></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>better</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'><a
      href="https://www.thoughtco.com/french-superlative-adverbs-1368958"><span
      style='color:#0086A6'>superlative</span></a></span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>le meilleur, la meilleure<br>
      les meilleurs, les meilleures</span></i></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>le mieux, la mieux<br>
      les mieux</span></i></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>the
      best</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='line-height:normal;background:white;vertical-align:
    baseline'><span style='font-size:16.5pt;font-family:"Helvetica",sans-serif;
    color:#282828;border:none windowtext 1.0pt;padding:0cm'>Deciding Between
    &quot;Bon&quot; and &quot;Bien&quot;</span></p>
    
    <p class=MsoNormal style='line-height:normal;background:white;vertical-align:
    baseline'><span style='font-size:13.0pt;font-family:"Georgia",serif;color:#282828'>Deciding
    whether you need&nbsp;<i><span style='border:none windowtext 1.0pt;padding:
    0cm'>meilleur</span></i>&nbsp;or&nbsp;<i><span style='border:none windowtext 1.0pt;
    padding:0cm'>mieux</span></i>&nbsp;is essentially a question of deciding
    between&nbsp;<a href="https://www.thoughtco.com/bon-vs-bien-1368817"><i><span
    style='color:#0086A6;border:none windowtext 1.0pt;padding:0cm;text-decoration:
    none'>bon</span></i><span style='color:#0086A6'>&nbsp;and&nbsp;</span><i><span
    style='color:#0086A6;border:none windowtext 1.0pt;padding:0cm;text-decoration:
    none'>bien</span></i></a>, but in a comparative or superlative
    construction.&nbsp;<i><span style='border:none windowtext 1.0pt;padding:0cm'>Bon</span></i>&nbsp;and&nbsp;<i><span
    style='border:none windowtext 1.0pt;padding:0cm'>bien</span></i>&nbsp;are often
    confused because they have somewhat similar meanings and they can both be
    adjectives, adverbs, or nouns.</span></p>
    
    <p class=MsoNormal style='line-height:normal;background:white;vertical-align:
    baseline'><span style='font-size:16.5pt;font-family:"Helvetica",sans-serif;
    color:#282828;border:none windowtext 1.0pt;padding:0cm'>&quot;Meilleur&quot;:
    The Comparative and Superlative Forms of &quot;Bon&quot;</span></p>
    
    <p class=MsoNormal style='line-height:normal;background:white;vertical-align:
    baseline'><span style='font-size:13.0pt;font-family:"Georgia",serif;color:#282828'>You
    can't say &quot;gooder&quot; or &quot;more good&quot; in English. And you can't
    say&nbsp;<i><span style='border:none windowtext 1.0pt;padding:0cm'>plus bon</span></i>&nbsp;in
    French; you'd say&nbsp;<i><span style='border:none windowtext 1.0pt;padding:
    0cm'>meilleur</span></i>&nbsp;(better), the&nbsp;comparative form of&nbsp;<i><span
    style='border:none windowtext 1.0pt;padding:0cm'>bon</span></i>, as follows::</span></p>
    
    <ul type=disc>
     <li class=MsoNormal style='color:#282828;line-height:normal;background:white;
         vertical-align:baseline'><i><span style='font-size:13.0pt;font-family:
         "Georgia",serif;border:none windowtext 1.0pt;padding:0cm'>Meilleur</span></i><span
         style='font-size:13.0pt;font-family:"Georgia",serif'>&nbsp;(masculine
         singular)</span></li>
     <li class=MsoNormal style='color:#282828;line-height:normal;background:white;
         vertical-align:baseline'><i><span style='font-size:13.0pt;font-family:
         "Georgia",serif;border:none windowtext 1.0pt;padding:0cm'>Meilleure</span></i><span
         style='font-size:13.0pt;font-family:"Georgia",serif'>&nbsp;(feminine
         singular)</span></li>
     <li class=MsoNormal style='color:#282828;line-height:normal;background:white;
         vertical-align:baseline'><i><span style='font-size:13.0pt;font-family:
         "Georgia",serif;border:none windowtext 1.0pt;padding:0cm'>Meilleurs</span></i><span
         style='font-size:13.0pt;font-family:"Georgia",serif'>&nbsp;(masculine
         plural)</span></li>
     <li class=MsoNormal style='color:#282828;line-height:normal;background:white;
         vertical-align:baseline'><i><span style='font-size:13.0pt;font-family:
         "Georgia",serif;border:none windowtext 1.0pt;padding:0cm'>Meilleures</span></i><span
         style='font-size:13.0pt;font-family:"Georgia",serif'>&nbsp;(feminine
         plural)</span></li>
    </ul>
    
    <p class=MsoNormal style='line-height:normal;background:white;vertical-align:
    baseline'><span style='font-size:13.0pt;font-family:"Georgia",serif;color:#282828'>&nbsp;
    An example of this use would be:&nbsp;</span></p>
    
    <ul type=disc>
     <li class=MsoNormal style='color:#282828;line-height:normal;background:white;
         vertical-align:baseline'><span style='font-size:13.0pt;font-family:"Georgia",serif'>&nbsp;</span><i><span
         lang=FR style='font-size:13.0pt;font-family:"Georgia",serif;border:none windowtext 1.0pt;
         padding:0cm'>Mes idées sont meilleures que tes idées. </span></i><i><span
         style='font-size:13.0pt;font-family:"Georgia",serif;border:none windowtext 1.0pt;
         padding:0cm'>&gt;&nbsp;</span></i><span style='font-size:13.0pt;
         font-family:"Georgia",serif'>My ideas are better than your ideas.</span></li>
    </ul>
    
    <p class=MsoNormal style='line-height:normal;background:white;vertical-align:
    baseline'><span style='font-size:13.0pt;font-family:"Georgia",serif;color:#282828'>The
    same rule applies to the superlative. Just as you can't say &quot;the
    goodest&quot; in English, you likewise can't say&nbsp;<i><span
    style='border:none windowtext 1.0pt;padding:0cm'>le plus bon</span></i>&nbsp;in
    French. You'd say&nbsp;<i><span style='border:none windowtext 1.0pt;padding:
    0cm'>le meilleur</span></i>&nbsp;(the best),&nbsp;the&nbsp;superlative form
    for&nbsp;<i><span style='border:none windowtext 1.0pt;padding:0cm'>bon</span></i>:</span></p>
    
    <ul type=disc>
     <li class=MsoNormal style='color:#282828;line-height:normal;background:white;
         vertical-align:baseline'><i><span style='font-size:13.0pt;font-family:
         "Georgia",serif;border:none windowtext 1.0pt;padding:0cm'>le meilleur</span></i><span
         style='font-size:13.0pt;font-family:"Georgia",serif'>&nbsp;(masculine
         singular)</span></li>
     <li class=MsoNormal style='color:#282828;line-height:normal;background:white;
         vertical-align:baseline'><i><span style='font-size:13.0pt;font-family:
         "Georgia",serif;border:none windowtext 1.0pt;padding:0cm'>la meilleure</span></i><span
         style='font-size:13.0pt;font-family:"Georgia",serif'>&nbsp;(feminine
         singular)</span></li>
     <li class=MsoNormal style='color:#282828;line-height:normal;background:white;
         vertical-align:baseline'><i><span style='font-size:13.0pt;font-family:
         "Georgia",serif;border:none windowtext 1.0pt;padding:0cm'>les meilleurs</span></i><span
         style='font-size:13.0pt;font-family:"Georgia",serif'>&nbsp;(masculine
         plural)</span></li>
     <li class=MsoNormal style='color:#282828;line-height:normal;background:white;
         vertical-align:baseline'><i><span style='font-size:13.0pt;font-family:
         "Georgia",serif;border:none windowtext 1.0pt;padding:0cm'>les meilleures</span></i><span
         style='font-size:13.0pt;font-family:"Georgia",serif'>&nbsp;(feminine
         plural)</span></li>
    </ul>
    
    <p class=MsoNormal style='line-height:normal;background:white;vertical-align:
    baseline'><span style='font-size:13.0pt;font-family:"Georgia",serif;color:#282828'>An
    example of this use would be:</span></p>
    
    <ul type=disc>
     <li class=MsoNormal style='color:#282828;line-height:normal;background:white;
         vertical-align:baseline'><i><span lang=FR style='font-size:13.0pt;
         font-family:"Georgia",serif;border:none windowtext 1.0pt;padding:0cm'>Son
         idée est la meilleure. </span></i><i><span style='font-size:13.0pt;
         font-family:"Georgia",serif;border:none windowtext 1.0pt;padding:0cm'>&gt;&nbsp;</span></i><span
         style='font-size:13.0pt;font-family:"Georgia",serif'>His idea is the best.</span></li>
    </ul>
    
    <p class=MsoNormal style='line-height:normal;background:white;vertical-align:
    baseline'><span style='font-size:16.5pt;font-family:"Helvetica",sans-serif;
    color:#282828;border:none windowtext 1.0pt;padding:0cm'>Using
    &quot;Meilleur&quot; or&nbsp;&quot;Mieux&quot;</span></p>
    
    <p class=MsoNormal style='line-height:normal;background:white;vertical-align:
    baseline'><span style='font-size:13.0pt;font-family:"Georgia",serif;color:#282828'>Generally
    speaking, use&nbsp;<i><span style='border:none windowtext 1.0pt;padding:0cm'>meilleur</span></i>&nbsp;when
    comparing nouns and&nbsp;<i><span style='border:none windowtext 1.0pt;
    padding:0cm'>mieux</span></i>&nbsp;to modify verbs.</span></p>
    
    <table class=MsoNormalTable border=0 cellspacing=0 cellpadding=0
     style='border-collapse:collapse'>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>Statement</span></b></p>
      </td>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-left:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>Comparative</span></b></p>
      </td>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-left:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>Superlative</span></b></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>Il a une bonne place.</span></i></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>Il veut une meilleure place.</span></i></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>Il veut la meilleure place.</span></i></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>He
      has a good seat.</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>He
      wants a better seat.</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>He
      wants the best seat.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'></td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'></td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'></td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>C'est un bon film.</span></i></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>C'est un meilleur film.</span></i></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>C'est le meilleur film.</span></i></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>It's
      a good movie.</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>It's
      a better movie.</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>It's
      the best movie.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'></td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'></td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'></td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>Elle s'habille bien.</span></i></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>Il s'habille mieux.</span></i></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>Je m'habille le mieux.</span></i></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>She
      dresses well.</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>He
      dresses better.</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>I
      dress the best.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'></td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'></td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'></td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>J'écris bien.</span></i></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>Tu écris mieux (que moi).</span></i></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>Il écrit le mieux (de tout).</span></i></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>I
      write well.</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>You
      write better (than I).</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>He
      writes the best (of all).</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='line-height:normal;background:white;vertical-align:
    baseline'><span style='font-size:16.5pt;font-family:"Helvetica",sans-serif;
    color:#282828;border:none windowtext 1.0pt;padding:0cm'>Copular Verbs</span></p>
    
    <p class=MsoNormal style='line-height:normal;background:white;vertical-align:
    baseline'><span style='font-size:13.0pt;font-family:"Georgia",serif;color:#282828'>Note
    that with&nbsp;<i><span style='border:none windowtext 1.0pt;padding:0cm'>&ecirc;tre</span></i>&nbsp;and
    other copular (state-of-being) verbs,&nbsp;<i><span style='border:none windowtext 1.0pt;
    padding:0cm'>mieux</span></i>&nbsp;is usually used except when you are
    comparing a noun in the sentence, in which case you need&nbsp;<i><span
    style='border:none windowtext 1.0pt;padding:0cm'>meilleur</span></i>. Again,
    think about whether&nbsp;<i><span style='border:none windowtext 1.0pt;
    padding:0cm'>bien</span></i>&nbsp;or&nbsp;<i><span style='border:none windowtext 1.0pt;
    padding:0cm'>bon</span></i>&nbsp;would be used in order to decide whether you
    need&nbsp;<i><span style='border:none windowtext 1.0pt;padding:0cm'>mieux</span></i>&nbsp;or&nbsp;<i><span
    style='border:none windowtext 1.0pt;padding:0cm'>meilleur</span></i>.</span></p>
    
    <table class=MsoNormalTable border=0 cellspacing=0 cellpadding=0
     style='border-collapse:collapse'>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>Expressions with mieux</span></b></p>
      </td>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-left:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>Expressions with meilleur</span></b></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>Je vais mieux maintenant.</span></i></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>Cette loi est meilleure.</span></i></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>I'm
      doing/feeling better now.</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>This
      law is better.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'></td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'></td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>Luc est mieux comme ami.</span></i></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>Je la trouve meilleure (que
      l'autre).</span></i></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>Luc
      is better as a friend.</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>I
      think it's better (than the other one).</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'></td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'></td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>C'est mieux de dire la vérité.</span></i></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif;
      border:none windowtext 1.0pt;padding:0cm'>La meilleure chose, c'est de dire
      la vérité.</span></i></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>It's
      better to tell the truth.</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>The
      best thing is to tell the truth.</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal>&nbsp;</p>
    
    </div>


`;
}